// Copyright (C) 2019 TANNER AG

import React from "react";
import * as PropTypes from "prop-types";
import { compose } from "recompose";
import { withStyles, IconButton } from "@material-ui/core"
import ArrowLeftIcon from "@material-ui/icons/KeyboardBackspace"
import { HeaderItem } from "./item";
import { withStore } from "../../store/withstore";
import { withRouter } from "react-router-dom";

const styles = {
	wrapper: {
		position: "fixed",
		top: 0,
		left: 0,
		zIndex: 999,
		width: "100%",
		display: "block",
		height: "100px",
		boxShadow: "0 3px 3px 0 rgba(48,60,73,0.15)",
		backgroundColor: "#F0F1F2"
	},
	progress: {
		content: '""',
		display: "block",
		backgroundColor: "#e40045",
		height: 3,
		width: 0,
		transition: "width 0.6s"
	},
	separator: {
		position: "absolute",
		top: 0,
		left: "50%",
		width: "1px",
		backgroundColor: "rgba(48,60,73,0.15)",
		height: "100px",
		"&:before": {
			content: '"VS"',
			position: 'absolute',
			height: 40,
			width: 40,
			top: "50%",
			transform: "translate(-50%, -50%)",
			boxShadow: "0 0 5px 0 #E2E3E4",
			backgroundColor: '#fff',
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			fontSize: 12,
			color: "#9DA3A9",
			fontFamily: 'MAN-light, Arial, sans-serif'
		}
	},
	itemWrapper: {
		position: "relative",
		display: "flex",
		flexWrap: "wrap",
		alignItems: "center",
		height: "100%"
	},
	backIcon: {
		position: "absolute",
		top: "50%",
		transform: "translateY(-50%)",
		left: "30px",
		color: "#303c49",
		zIndex: 999
	}
};

const Header = (props) => {
	const { classes, store: { a, b }, history, backRoute } = props;
	return (
		<div className={classes.wrapper}>
			<IconButton
				aria-label="Back"
				classes={{ root: classes.backIcon }}
				onClick={() => history.push(backRoute)}
			>
				<ArrowLeftIcon />
			</IconButton>
			<div className={classes.itemWrapper}>
				<HeaderItem
					name={a.bus.name}
					doors={a.bus.doors}
					fuel={a.bus.fuel}
					type={a.bus.type}
				/>
				<HeaderItem
					name={b.bus.name}
					doors={b.bus.doors}
					fuel={b.bus.fuel}
					type={b.bus.type}
				/>
				<div className={classes.separator}/>
			</div>
			<span className={classes.progress} style={{ width: props.progress + "%" }}/>
		</div>
	);
};

Header.propTypes = {
	progress: PropTypes.number,
	store: PropTypes.object,
	history: PropTypes.object,
	backRoute: PropTypes.string
};

Header.defaultProps = {
	progress: 0,
	backRoute: "/tco-lcc"
};

export default compose(
	withRouter,
	withStore,
	withStyles(styles)
)(Header);



// WEBPACK FOOTER //
// ./src/tco/configuration/header/index.js